import React from 'react';
import styles from './EditButton.module.css';

export default function EditButton({ handleEdit }) {
    return (
        <div className={styles.buttonContainer}>
            <button onClick={handleEdit} className={styles.editButton}>Edit</button>
        </div>

    );
};;